const size = {
    sm : "500px",
    md : "850px",
    lg : "1023px",
    xl : "1440px",
    xxl : "1740px"
};

const theme = {
    colors : {
        mainBlack    : `#000000`,
        darkGray     : `#353639`,
        middleGray01 : `#7B7D81`,
        middleGray02 : `#A6A7AB`,
        lightGray01  : `#D1D5DB`,
        lightGray02  : `#E5E7EB`,
        sideMenu     : `#F3F4F6`,
        mainWhite    : `#FFFFFF`,
        pointYellow  : `#FAB900`,
        pointOrange  : `#ED624B`,
        scrollBack   : `#F9FAFB`,
        scrollBar    : `#D9D9D9`,
        opacity_40   : `rgba(17, 24, 39, 0.40)`,
        red400       : `rgb(248 113 113)`,
        red500       : `rgb(239 68 68)`,
    },
    // 나중에 어느정도 정리되면 만들자
    typography : {

    },
    screens : {
        sm : `screen and (max-width : ${size.sm})`,
        md : `screen and (max-width : ${size.md})`,
        lg : `screen and (max-width : ${size.lg})`,
        xl : `screen and (max-width : ${size.xl})`,
        xxl : `screen and (max-width : ${size.xxl})`,
    },
    utility : {
        shadow_100 : `rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px`,
        shadow_200 : `0px 0px 10px 0px rgba(0, 0, 0, 0.10)`
    }
};

export default theme;